import script from "./YourExperienceStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./YourExperienceStep.vue?vue&type=script&setup=true&lang=ts"

import "./YourExperienceStep.vue?vue&type=style&index=0&id=0653a62d&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0653a62d"]])

export default __exports__